"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staffSalesApi = exports.mySalesApi = exports.pickUpApi = exports.ordersApi = void 0;
const ordersApi = async (axiosInstance, { status, fromDate, toDate, }) => {
    try {
        const _data = await axiosInstance.get(`admin/orders`, {
            params: {
                status,
                fromDate,
                toDate,
            },
        });
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.ordersApi = ordersApi;
const pickUpApi = async (axiosInstance, orderId) => {
    try {
        const _data = await axiosInstance.get(`admin/pickup/${orderId}`);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.pickUpApi = pickUpApi;
const mySalesApi = async (axiosInstance, { fromDate = new Date(), toDate = new Date(), }) => {
    try {
        const _data = await axiosInstance.get(`admin/sales/staff`, {
            params: { fromDate, toDate },
        });
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.mySalesApi = mySalesApi;
const staffSalesApi = async (axiosInstance, staffNumber) => {
    try {
        const _data = await axiosInstance.get(`admin/sales/staff/${staffNumber}`);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.staffSalesApi = staffSalesApi;
//# sourceMappingURL=admin.js.map